// Repos

export const allRepos =
  "https://api.github.com/users/OlSavMe/repos?per_page=100";

export const sortedRepos =
  "https://api.github.com/users/OlSavMe/repos?sort=updated&direction=desc&per_page=100";
